import React from 'react';

var TagSelectPopover = React.createClass({
  // 初始化 state，根据传入的 sections 动态生成 keys
  getInitialState: function() {
    var initialSections = [];
    if (this.props.tagSections && Array.isArray(this.props.tagSections)) {
      // 深拷贝并添加 selected 标志
      initialSections = JSON.parse(JSON.stringify(this.props.tagSections)).map(function(section) {
        if (section.v && Array.isArray(section.v)) {
          section.v = section.v.map(function(tag) {
            if(!tag.selected) {
              tag.selected = false; // 添加 selected 标志
            }
            return tag;
          });
        } else {
          section.v = []; // 确保 v 是数组
        }
        return section;
      });
    }
    return {
      sections: initialSections // 状态中存储带 selected 标志的数据
    };
  },

  // 清除按钮处理
  handleClear: function() {
     // 创建新的 sections 数组，将所有 selected 设置为 false
     var clearedSections = this.state.sections.map(function(section) {
      if (section.v) {
          section.v = section.v.map(function(tag) {
              tag.selected = false;
              return tag;
          });
      }
      return section;
  });
  // 使用深拷贝确保状态更新
  this.setState({ sections: JSON.parse(JSON.stringify(clearedSections)) });
  this.props.handleClear && this.props.handleClear(clearedSections);
  },

  // 确定按钮处理
  handleConfirm: function() {
    var allSelectedValues = [];
    // 遍历 state 中的 sections
    this.state.sections.forEach(function(section) {
      if (section.v) {
        section.v.forEach(function(tag) {
          if (tag.selected) {
            allSelectedValues.push(tag.v); // 收集选中标签的 'v' 值
          }
        });
      }
    });

    if (this.props.onConfirm) {
      this.props.onConfirm(allSelectedValues,  this.state.sections);
    }
  },

  // 切换标签选中状态
  toggleTag: function(sectionKey, tagKey) { // 使用 sectionKey 和 tagValue
   // 执行深拷贝以避免直接修改 state
   var newSections = JSON.parse(JSON.stringify(this.state.sections));

   // 找到对应的 section
   var targetSection = newSections.find(function(section) {
       return section.k === sectionKey;
   });

   if (targetSection && targetSection.v) {
       // 找到对应的 tag
       var targetTag = targetSection.v.find(function(tag) {
           // 假设 tag.k 是唯一标识符，如果不是，可能需要用 index 或 tag.v
           return tag.k === tagKey;
       });

       if (targetTag) {
           // 切换 selected 状态
           targetTag.selected = !targetTag.selected;
           // 更新 state
           this.setState({ sections: newSections });
       } else {
            console.warn('Tag not found for key:', tagKey, 'in section:', sectionKey);
       }
   } else {
       console.warn('Section not found for key:', sectionKey);
   }
  },

  // 渲染单个标签分组
  renderTagSection: function(sectionData) {
    var self = this;
    var sectionKey = sectionData.k;
    var title = sectionData.title;
    var tags = sectionData.v || [];

    return (
      <div className="tag-section" key={sectionKey}>
        <div className="section-title">{title}</div>
        <div className="tag-group">
          {tags.map(function(tagObj, index) {
            // 读取 tagObj 中的 selected 状态来决定样式
            var isSelected = tagObj.selected === true; // 显式检查 true
            // 使用 tagObj.k 作为唯一标识传递给 toggleTag
            var tagKey = tagObj.k;
            var tagValue = tagObj.v; // 显示的值

            // 如果 tag.k 不唯一或不存在，可以回退到使用 tag.v 或 index
            if (typeof tagKey === 'undefined') {
                console.warn('Warning: Tag object missing "k" property in section', sectionKey, '. Consider adding unique keys or using value/index.');
                // tagKey = tagValue; // 或者 tagKey = index; 作为备选
            }

            return (
              <button
                key={sectionKey + '-' + (tagKey || index)} // 优先使用 tagKey
                className={'tag' + (isSelected ? ' selected' : '')}
                // 传递 sectionKey 和 tagKey
                onClick={self.toggleTag.bind(self, sectionKey, tagKey)}
              >
                {tagValue}
              </button>
            );
          })}
        </div>
      </div>
    );
  },

  // 渲染主函数
  render: function() {
    var style = {
      position: 'fixed',
      bottom: this.props.position ? this.props.position.bottom : undefined,
      right: this.props.position ? this.props.position.right : undefined,
      visibility: this.props.position ? 'visible' : 'hidden'
    };

    return (
      <div className="tag-select-popover" style={style}>
        {/* 头部 */}
        <button className="close-button" onClick={this.props.onClose}>×</button>

        {/* 内容 - 现在从 state 渲染 */}
        <div className="popover-content">
          {this.state.sections.map(this.renderTagSection)}
        </div>

        {/* 底部 */}
        <div className="popover-footer">
          <button className="clear-button" onClick={this.handleClear}>清除</button>
          <button className="confirm-button" onClick={this.handleConfirm}>确定</button>
        </div>
      </div>
    );
  }
});

module.exports = TagSelectPopover;